import styles from './WelcomeScreenTwo.module.scss';
import { t } from 'i18next';

function WelcomeScreenTwo() {
  return (
    <div className={styles.screenContent}>
      <h3 className={styles.heading}>{t('NEED_HELP')}</h3>
      <p className={styles.body}>{t('WELCOME_MESSAGE_TWO')}</p>
    </div>
  );
}

export default WelcomeScreenTwo;
